module.exports = __webpack_public_path__ + "img/promo-banner.5de4789d.png";